import { useState } from "react";
import { usePubContext } from "../../hooks/pub-context";
import {
  YoutubeLiveButton,
  YoutubeLiveItem,
  YouTubeLiveListWrapper,
  YoutubeLiveWrapper,
} from "./style";
import { openNewWindow } from "../../../../../utils/common";

const PremiumPubYoutubeLive = () => {
  const { liveList } = usePubContext();
  const [listOpen, setListOpen] = useState<boolean>(true);

  return (
    <YoutubeLiveWrapper>
      <YoutubeLiveButton onClick={() => setListOpen(!listOpen)}>
        <img src="/image-web/store/youtube_live.png" alt="live" />
      </YoutubeLiveButton>
      <YouTubeLiveListWrapper listOpen={listOpen}>
        {liveList.map((item, index) => (
          <YoutubeLiveItem
            key={index}
            onClick={() => item.link && openNewWindow(item.link)}
          >
            <img src={item.imageUrl} alt="youtuber" />
            <div className="name">LIVE</div>
          </YoutubeLiveItem>
        ))}
      </YouTubeLiveListWrapper>
    </YoutubeLiveWrapper>
  );
};

export default PremiumPubYoutubeLive;
